let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c7do3")).then(() => parcelRequire('hJChc'));